import React from "react";
import classNames from "classnames";
import { Container } from "reactstrap";
import "./sidebar.css";
import Topbar from "./Topbar";
import Footer from "./footer";
import Breadcrumbs from "../components/breadcrumbs";

const Header = ({ children, sidebarIsOpen, toggleSidebar }) => (
  <Container
    fluid
    style={{
      height: "100vh",
      overflowX: "scroll",
      // overflowY:"hidden"
      padding: "0px",
    }}
    className={classNames("content", { "is-open": sidebarIsOpen })}
  >
    <div>
      <Topbar toggleSidebar={toggleSidebar} />
      <Breadcrumbs />
      <div className="sm:!px-6 px-2 py-3 rounded-full">
        {children}
      </div>
    </div>
    <Footer />
  </Container>
);

export default Header;
